import { VerifierCredentialStatus } from 'src/api';

export const MIDDESK_VERIFICATION_DISABLED_CREDENTIAL_STATUSES: VerifierCredentialStatus[] = [
  VerifierCredentialStatus.Credentialed,
  VerifierCredentialStatus.AwaitingApprovalByCv,
  VerifierCredentialStatus.MiddeskPending,
  VerifierCredentialStatus.Denied,
  VerifierCredentialStatus.DeniedByMiddesk,
];

export const MANUAL_VERIFICATION_DISABLED_CREDENTIAL_STATUSES: VerifierCredentialStatus[] = [
  VerifierCredentialStatus.NotCredentialed,
  VerifierCredentialStatus.Referred,
  VerifierCredentialStatus.MiddeskPending,
];
